import { $logicTranslator } from "../helper/globalFunction";

export const handleFieldState = ({ field, stateType, fieldConfig, logic }) => {
  if (logic[field] && logic[field][stateType]) {
    const statement = $logicTranslator(logic[field][stateType], fieldConfig);
    return statement;
  }

  return stateType == "disable" ? false : true;
};
